import { SignatureOutlined, FormOutlined, TagsOutlined } from '@ant-design/icons';
import {
  ActiveLog,
  DashboardNew,
  Settings,
  RealTimeChatNew,
  TelephonePlus,
  ChatRecordsNew,
  ReportsNew,
  Briefcase,
  Teams,
  AgentNew,
  ReportDashboard,
  Schedule,
  DocumentVerification
} from '../assets/icons/jsxIcons/index';

export const unifiedSidebarData = [
  {
    title: 'Dashboard',
    route: '',
    Icon: DashboardNew,
    index: 1,
    roles: ['super-admin', 'admin', 'user'] // Available to all roles
  },
  {
    title: 'Conversations',
    route: 'CONVERSATIONS',
    Icon: RealTimeChatNew,
    index: 2,
    roles: ['super-admin', 'admin', 'user'] // Available to all roles
  },
  {
    title: 'Call Requests',
    route: 'CALL-REQUESTS',
    Icon: TelephonePlus,
    index: 3,
    feature: ['callback_request', 'calendar_scheduling'],
    roles: ['super-admin', 'admin', 'user'] // Available to all roles
  },
  {
    title: 'Documents',
    navLabel: 'Doc...',
    route: 'DOCUMENTS',
    Icon: DocumentVerification,
    badge: 'New',
    feature: ['esignature', 'document_verification'],
    roles: ['super-admin', 'admin'], // Not available to regular users
    children: [
      {
        title: 'eSign',
        route: 'esignature',
        Icon: SignatureOutlined,
        badge: '',
        feature: 'esignature',
        roles: ['super-admin', 'admin']
      },
      {
        title: 'Forms',
        route: 'esignature/templates',
        Icon: FormOutlined,
        badge: '',
        feature: 'esignature',
        roles: ['super-admin'] // Only super-admin
      },
      {
        title: 'Verify',
        route: 'VERIFICATION',
        Icon: DocumentVerification,
        badge: '',
        feature: 'document_verification',
        roles: ['super-admin', 'admin']
      }
    ]
  },
  {
    title: 'Records',
    route: 'RECORDS',
    Icon: ChatRecordsNew,
    index: 4,
    roles: ['super-admin', 'admin', 'user'], // Available to all roles
    children: [
      {
        title: 'Interactions',
        route: 'RECORDS',
        Icon: ChatRecordsNew,
        feature: 'call_recording',
        roles: ['super-admin', 'admin', 'user']
      },
      {
        title: 'Tickets',
        route: 'TICKETS',
        Icon: TagsOutlined,
        roles: ['super-admin', 'admin', 'user']
      }
    ]
  },
  {
    title: 'Reports',
    route: 'REPORTS',
    Icon: ReportsNew,
    index: 5,
    roles: ['super-admin', 'admin'], // Not available to regular users
    children: [
      {
        title: 'Analytics',
        route: 'REPORTS',
        Icon: ReportDashboard,
        feature: 'analytics_reporting',
        roles: ['super-admin', 'admin']
      },
      {
        title: 'Scheduler',
        route: 'SCHEDULER',
        Icon: Schedule,
        feature: 'calendar_scheduling',
        roles: ['super-admin', 'admin']
      },
      {
        title: 'Logs',
        route: 'LOGS',
        Icon: ActiveLog,
        index: 8,
        feature: 'analytics_reporting',
        roles: ['super-admin', 'admin']
      }
    ]
  },
  {
    title: 'Departments',
    route: 'departments',
    Icon: Briefcase,
    roles: ['super-admin', 'admin'], // Not available to regular users
    children: [
      {
        title: 'Teams',
        route: 'teams',
        Icon: Teams,
        roles: ['super-admin', 'admin']
      },
      {
        title: 'Agents',
        route: 'agents',
        Icon: AgentNew,
        roles: ['super-admin', 'admin']
      }
    ]
  },
  {
    title: 'Settings',
    route: 'SETTINGS',
    Icon: Settings,
    roles: ['super-admin'] // Only super-admin
  }
];
